// extracted by mini-css-extract-plugin
export default {"strong":"ReviewTopicsList_strong__dgXFC","summary":"ReviewTopicsList_summary__XXgHA","wysiwyg":"ReviewTopicsList_wysiwyg__Q2XOM"};